<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <div class="vx-row">

      <!-- Col 1 -->
      <div class="vx-col w-full md:w-1/2">
        <!-- <vs-input
          class="w-full"
          v-model="serverData.emailSenderDriverTypeId"
          label="Protocolo"
          @input="setTwitter"
          icon-no-border
          name="twitter" /> -->

          <label for="" class="vs-input--label">Protocolo</label>
          <v-select :options="driverOptions" label="name" @input="setEmailProtocol" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="serverData.emailSenderDriverTypeId" class="w-full"/>
           <!-- class="mb-4 md:mb-0"  -->

          <vs-input
          class="w-full mt-4"
          v-model="serverData.emailSenderPort"
          label="Porta do servidor de email"
          @input="setEmailPort"
          icon-no-border
          name="facebook" />

          <vs-input
          class="w-full mt-4"
          v-model="serverData.emailSenderFromName"
          label="Nome do remetente"
          @input="setEmailFromName"
          icon-no-border
          name="instagram" />

          <vs-input
          class="w-full mt-4"
          v-model="serverData.emailSenderPassword"
          label="Senha de autenticação"
          @input="setEmailPassword"
          icon-no-border
          name="slack" />

      </div>

      <!-- Col 2 -->
      <div class="vx-col w-full md:w-1/2">

        <vs-input
            class="w-full"
            v-model="serverData.emailSenderHost"
            label="Host do servidor de email"
            @input="setEmailHost"
            icon-no-border
            name="twitter" />

        <vs-input
          class="w-full mt-4"
          v-model="serverData.emailSenderFromAddress"
          label="Email do remetente"
          @input="setEmailFromAddress"
          icon-no-border
          name="github" />

        <vs-input
          class="w-full mt-4"
          v-model="serverData.emailSenderUsername"
          label="Email de autenticação"
          @input="setEmailUsername"
          icon-no-border
          name="codepen" />

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Salvar Alterações</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      driverOptions: [
        {
          id: 1,
          name: 'SMTP'
        },
        {
          id: 2,
          name: 'IMAP'
        }
      ],

      serverData: {
        emailSenderDriverTypeId: {
          id: 1,
          name: 'SMTP'
        },
        emailSenderPort: '',
        emailSenderFromName: '',
        emailSenderHost: '',
        emailSenderFromAddress: '',
        emailSenderUsername: '',
        emailSenderPassword: ''
      },

      data_local: null
    }
  },
  created() {
    setTimeout(() => {
      this.serverData.emailSenderDriverTypeId = this.driverOptions.find(x => x.id === this.$store.state.applicationManagement.settings.emailSenderDriverTypeId)
      this.serverData.emailSenderPort = this.$store.state.applicationManagement.settings.emailSenderPort
      this.serverData.emailSenderFromName = this.$store.state.applicationManagement.settings.emailSenderFromName
      this.serverData.emailSenderHost = this.$store.state.applicationManagement.settings.emailSenderHost
      this.serverData.emailSenderFromAddress = this.$store.state.applicationManagement.settings.emailSenderFromAddress
      this.serverData.emailSenderUsername = this.$store.state.applicationManagement.settings.emailSenderUsername
      this.serverData.emailSenderPassword = this.$store.state.applicationManagement.settings.emailSenderPassword
    }, 300)
  },
  computed: {
    validateForm () {

      const specialRegex = new RegExp('^[0-9a-zA-Z ãâáàéêè\b]+$')

      // if (/\s/.test(this.$store.state.applicationManagement.userProfile.name) && this.$store.state.applicationManagement.userProfile.name.trim() === '') {
      //   this.$vs.notify({
      //     title: 'Warning',
      //     text: 'The name field in Account Tab must be a valid name',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning'
      //   })

      //   return false
      // }


      return !this.errors.any()
    }
  },
  methods: {
    setEmailProtocol (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PROTOCOL', e.id)
    },
    setEmailPort (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PORT', e)
    },
    setEmailFromName (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_NAME', e)
    },
    setEmailHost (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_HOST', e)
    },
    setEmailFromAddress (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_FROM_ADDRESS', e)
    },
    setEmailUsername (e) {
      this.$store.commit('applicationManagement/SET_EMAIL_USERNAME', e)
    },
    setEmailPassword(e) {
      this.$store.commit('applicationManagement/SET_EMAIL_PASSWORD', e)
    },
    async fetch_user_data (userSession, appToken, apiUrl) {
      this.$vs.loading({type: 'default'})
      return await this.$store.dispatch('applicationManagement/fetchUserProfile', {userSession, appToken, apiUrl})
        .then((res) => {
          this.$vs.loading.close()
          this.$store.dispatch('applicationManagement/setUserProfile', res)
          this.user_data = res
        })
        .catch(err => {
          this.$vs.loading.close()
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) 
        })
    },
    save_changes () {
      /* eslint-disable */
      if (!this.validateForm) return

      this.$vs.loading({type: 'default'})

      this.$store.dispatch('applicationManagement/saveChanges', {userProfile: this.$store.state.applicationManagement.userProfile, apiUrl: this.$store.state.auth.api_url})
      .then(async (result) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Operação Realizada!',
            text: `Dados alterados com sucesso!`,
            iconPack: 'feather',
            icon: 'icon-success-circle',
            color: 'success'
          })

      })
      .catch((err) => {
        this.$vs.loading.close()

        this.$vs.notify({
            title: 'Erro',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
        })
      })

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
    },
    reset_data () {
      this.data_local = Object.assign({}, this.data)
    }
  }
}
</script>
